import type { EmailBusinessInfo } from "@components/Tax Pro Only/Modals/EmailModal/types.ts";

/**
 * Combines the first name and last name into a single full name.
 *
 * @param {string} firstName - The first name of the person.
 * @param {string} lastName - The last name of the person.
 * @return {string} The full name derived by combining the first and last name.
 */
export function createName(firstName: string, lastName: string): string {
  return `${firstName} ${lastName}`;
}

/**
 * Creates the email signature from business info.
 * @param businessInfo
 */
export function getSignatureName(businessInfo: EmailBusinessInfo | null) {
  if (!businessInfo) return "";

  const { name, businessName } = businessInfo;
  if (!name) return businessName;
  if (!businessName) return name;
  return `${name} at ${businessName}`;
}

/**
 * Extract the taxpros personal and business info.
 */
export function getTaxProEmailInfo() {
  const personalInfo = localStorage.getItem("personalInfo")
    ? JSON.parse(localStorage.getItem("personalInfo") as string)
    : null;
  const businessInfo = localStorage.getItem("businessInfo")
    ? JSON.parse(localStorage.getItem("businessInfo") as string)
    : null;
  return { personalInfo, businessInfo };
}

/**
 * Converts a file to a Base64-encoded string.
 */
export const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = (reader.result as string).split(",")[1]; // Remove the prefix (data:mime/type;base64,)
      resolve(base64String);
    };
    reader.onerror = (e) => {
      console.error(e);
      reject(new Error("Failed to read the file as Data URL"));
    };
  });
};

/**
 * Estimates file size in MB from a Base64 string.
 */
export const getFileSize = (base64String: string): string => {
  const sizeInBytes = (base64String.length * 3) / 4; // Base64 is 4/3 larger than the original size
  return (sizeInBytes / 1024 / 1024).toFixed(1);
};
